<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card style="height: 635px;">
          <template v-slot:body>
            <b-col xs="12" sm="12" class=" mt-3 text-left">
              <b-row>
              <b-button variant="primary" @click="pdfExport" style="margin-left: 76%;margin-right: 10px;z-index:100;">
                  Export  Pdf
              </b-button>
              <b-button type="button" variant="primary" class="mr-2" @click="printID" style="z-index:100;">{{ $t('globalTrans.print') }}</b-button>
              </b-row>
            </b-col>
            <div id="printMe">
            <b-row class="seconddtrans">
                    <div class="firsttrans">
                        <b-img width='300px' :src="awarenessEventServiceBaseUrl+'storage/'+certificate_logo" fluid alt="Right Logo" style="opacity:0.1;"></b-img>
                    </div>
                    <table class="newtable" style="width:100%;color: black;">
                              <tr>
                                <th style="font-size: 29px;padding: 15px !important;letter-spacing: 1px;font-weight: 100;-webkit-transform: scale(1,1.2);-moz-transform: scale(1,1.2);-ms-transform: scale(1,1.2);-o-transform: scale(1,1.2);transform: scale(1,1.2);" class="firstfont">{{$t('externalUser.certificate_of_participation')}}</th>
                              </tr>
                              <tr>
                                <td class="newtabledata" style="font-size: 20px;font-weight: 600;padding: 5px!important;-webkit-transform: scale(1,1.2);-moz-transform: scale(1,1.2);-ms-transform: scale(1,1.2);-o-transform: scale(1,1.2);transform: scale(1,1.2);border-left: 1px solid black!important;border-right: 1px solid black!important;">{{$t('externalUser.this_certificate_text')}}</td>
                              </tr>
                              <tr v-if="item">
                                <td class="newtabledata" style="font-size: 22px;font-weight: 600;padding: 10px!important;text-decoration: underline;-webkit-transform: scale(1,1.2);-moz-transform: scale(1,1.2);-ms-transform: scale(1,1.2);-o-transform: scale(1,1.2);transform: scale(1,1.2);border-left: 1px solid black!important;border-right: 1px solid black!important;" v-if="item">{{item.org_name}}</td>
                              </tr>
                              <tr>
                                <td style="font-size: 20px;padding: 15px!important;-webkit-transform: scale(1,1.2);font-weight: 500;-moz-transform: scale(1,1.2);-ms-transform: scale(1,1.2);-o-transform: scale(1,1.2);transform: scale(1,1.2);border-left: 1px solid black!important;border-right: 1px solid black!important;" class="newtabledata">{{$t('externalUser.for_successfully_text')}}</td>
                              </tr>
                              <tr v-if="item">
                                <td class="newtabledata" style="padding-top: 10px!important;font-size: 19px;text-decoration: underline;-webkit-transform: scale(1,1.2);-moz-transform: scale(1,1.2);-ms-transform: scale(1,1.2);-o-transform: scale(1,1.2);transform: scale(1,1.2);border-left: 1px solid black!important;border-right: 1px solid black!important;" v-if="item"><b>{{item.event_info}}</b></td>
                              </tr>
                              <tr v-if="item">
                                <td class="newtabledata" style="padding-bottom: 10px!important;font-size: 16px;text-decoration: underline;-webkit-transform: scale(1,1.2);-moz-transform: scale(1,1.2);-ms-transform: scale(1,1.2);-o-transform: scale(1,1.2);transform: scale(1,1.2);border-left: 1px solid black!important;border-right: 1px solid black!important;" v-if="item"><b>{{item.location}}</b></td>
                              </tr>
                              <tr v-if="item">
                                <td class="newtabledata" style="padding: 15px!important;-webkit-transform: scale(1,1.2);-moz-transform: scale(1,1.2);-ms-transform: scale(1,1.2);-o-transform: scale(1,1.2);transform: scale(1,1.2);border-left: 1px solid black!important;border-right: 1px solid black!important;"><b style="text-decoration: underline;">{{item.start_date}}</b> - <b style="text-decoration: underline;">{{item.end_date}}</b></td>
                              </tr>
                              <tr>
                                <td class="newtabledata" style="font-size: 17px;padding-bottom: 25px!important;-webkit-transform: scale(1,1.2);-moz-transform: scale(1,1.2);-ms-transform: scale(1,1.2);-o-transform: scale(1,1.2);transform: scale(1,1.2);border-left: 1px solid black!important;border-right: 1px solid black!important;">{{$t('externalUser.issued_by')}}</td>
                              </tr>
                              <tr>
                                <td class="newtabledata" style="font-size: 29px;font-weight: 600;text-decoration: underline;-webkit-transform: scale(1,1.2);-moz-transform: scale(1,1.2);-ms-transform: scale(1,1.2);-o-transform: scale(1,1.2);transform: scale(1,1.2);border-left: 1px solid black!important;border-right: 1px solid black!important;border-bottom: 1px solid black!important;">{{$t('externalUser.jatio_protibondhi_text')}}</td>
                              </tr>
                    </table>
              </b-row>
              </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import { stallParticipantCertificateData, reportHeadingListNew } from '../../api/routes'
import ExportPdf from './export-pdf_details'
import VueHtmlToPaper from 'vue-html-to-paper'
import Vue from 'vue'
const options = {
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=no'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    `${awarenessEventServiceBaseUrl}/print.css`
  ],
  autoClose: true
}
Vue.use(VueHtmlToPaper, options)
export default {
  props: ['id', 'item'],
  components: {
  },
  data () {
    return {
      retrivedData: [],
      formData: [],
      certificate_logo: '',
      awarenessEventServiceBaseUrl: awarenessEventServiceBaseUrl
    }
  },
  created () {
    RestApi.getData(awarenessEventServiceBaseUrl, reportHeadingListNew, 0).then(response => {
        if (response.success) {
          this.certificate_logo = response.data.certificate_logo
        }
    })
    const userId = this.$store.state.Auth.authUser.id
    const params = Object.assign({}, this.formData, { user: userId })
    RestApi.getData(awarenessEventServiceBaseUrl, stallParticipantCertificateData, params).then(response => {
    if (response.success) {
         this.retrivedData = response.data
    }
    })
    if (this.id) {
        const tmp = this.getEligibityCategory()
        this.formData = tmp
    }
  },
  mounted () {
    core.index()
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
  },
  methods: {
    pdfExport () {
      const reportTitle = this.$t('production_service_config.dealer_info')
      ExportPdf.exportPdfDetails(reportTitle, this.formData, this, this.item)
    },
    printID () {
      this.$htmlToPaper('printMe')
    },
    getEligibityCategory () {
        const tmpData = this.$store.state.list.find(item => item.id === parseInt(this.id))
        return JSON.parse(JSON.stringify(tmpData))
    }
  }
}
</script>
<style lang="scss">
    .details {
    h5 {
      color: black !important;
      font-size: 20px !important;
    }
    // .table-bordered td:nth-child(2n+1) {
    //   font-weight: 700;
    // }
  }
  .hidden_header {
    display: none
  }
</style>
<style>
/* @import url(//db.onlinewebfonts.com/c/861d9af1555d1776aaf9b0f5a7de1199?family=Matura+MT+Std);
@import url(//db.onlinewebfonts.com/c/c8e367ed921e0b64eb40752644e1e353?family=Bradley+Hand+ITC+TT);
@import url(//db.onlinewebfonts.com/c/1b0cd802bec637490d914d4b503f7fec?family=AureliaEF); */
@import url(//db.onlinewebfonts.com/c/952bab25f6798d6bb1937d67e9bee4dd?family=Sans);
  .newtable {
  border: 1px solid black;
  }
  .firstfont {
    font-family: 'Sans'!important;
  }

  .secondfont {
    font-family: 'Sans'!important;
  }

  .thirdfont {
    font-family: 'Sans'!important;
  }

  table {
    border-collapse: collapse;
    width: 100%;
  }

  th {
    text-align: center!important;
  }

  td {
    text-align: center!important;
    background-color: transparent!important;
  }
  .firsttrans {
    transform: translate(212px,407px);
  }
  .seconddtrans {
    transform: translateY(-269px);
  }
  .uniquetrone {
      border:1px solid white;
  }
  .uniquetrtwo {
      border:none;
  }
</style>
